import React from "react";
import propTypes from 'prop-types';
import classnames from "classnames";
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { multiplier } from '_ui-core-js/utilities/multiplier.js';

export function EditiorialHeading (props) {
    const { applyLbxTheme, block, subtitle, title } = props
    return (
        <div className={`${block}__heading-wrapper`}>
            <h2 className={`${block}__heading h1`}>
                <div>
                    {subtitle &&
                        subtitle
                            .toString()
                            .split(' ')
                            ?.map((word, index) => (
                                <CssAnimation
                                    enter={{
                                        name: 'long-slide-up-fade-in',
                                        delay: `${multiplier(
                                            index,
                                            0.25
                                        )}, hidden`,
                                        duration: 0.5
                                    }}
                                    triggerEnter={'in-view-init'}
                                    key={word}
                                >
                                    <span className={`${block}__lead-text h2`}>
                                        {word}
                                    </span>
                                </CssAnimation>
                            ))
                    }
                </div>
                
                {title &&
                    title
                        .split(' ')
                        ?.map((word, index) => (
                            <CssAnimation
                                enter={{
                                    name: 'long-slide-up-fade-in',
                                    delay: `${multiplier(
                                        index,
                                        0.25
                                    )}, hidden`,
                                    duration: 0.5
                                }}
                                triggerEnter={'in-view-init'}
                                key={word}
                            >
                                <span className={
                                    classnames({
                                        [`${block}__heading-text`]: true,
                                        ['apply-lbx-theme-text']: applyLbxTheme,
                                        'headline-var-1': true
                                    })}>
                                    {word}
                                </span>
                            </CssAnimation>
                        ))
                }
            </h2>
        </div>
    ) 
}

EditiorialHeading.propTypes = {
    applyLbxTheme: propTypes.bool,
    block: propTypes.string,
    title: propTypes.string, 
    subtitle: propTypes.string, 
};